module.exports = __webpack_public_path__ + "static/media/buttonOn.73f135bc.png";